<template>
  <div style="max-height: 1920px;">
    <!-- <v-img
      width="100%"
      height="auto"
      class="fullscreen"
      style="padding-top: 3%"
    >
      <div>
        <v-container>
          <v-row>
            <v-card
              elevation="0"
              width="900"
              height="1800"
              style="
                background-color: white;
              "
              class="align-center pa-4 mx-auto"
            >
              <v-row
                style="    display: flex;
    justify-content: flex-end;padding-right: 40px;padding-top: 10%"
              >
                <v-progress-circular indeterminate size="100 "></v-progress-circular>
              </v-row>

              <v-row style="margin-top: 10%">
                <v-col
                  cols="12"
                  md="12"
                  style="
                    text-align: center;
                    font-size: 60px;
                    color: #126496;
                    font-weight: bold;
                  "
                >
                  {{ $t("message.Pleaseinsert") }}
                </v-col>
              </v-row>
              <v-row style="margin-top: 20%">
                <v-col cols="12" md="12" style="text-align: center">
                  <img
                    @click="CapturePerson()"
                    height="auto"
                    width="450px"
                    style="
                      padding-top: 0rem;
                      margin-left: auto;
                      margin-right: auto;
                      cursor: pointer;
                    "
                    src="@/assets/id-card.png"
                  />
                </v-col>
              </v-row>
              <v-row style="margin-top: 25%">
                <v-col cols="12" md="12" style="text-align: center">
                  <v-btn
                    color="#344054"
                    class="box white--text mt-2 text-capitalize"
                    router
                    width="500"
                    style="font-size: 45px"
                    height="100"
                    @click="BackToIdentifySelection()"
                    >{{ $t("message.Back") }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-row>
        </v-container>
      </div>
    </v-img> -->

    <v-row>
      <v-col cols="12" md="12" style="text-align: center;">

        <v-sheet class="folded-corner" width="1080" height="1300" style="margin-top: 550px">
          <v-container>
            <v-row>
              <v-card elevation="0" width="900" height="1800" style="
                background-color: white;
              " class="align-center pa-4 mx-auto">
             

                <v-row style="margin-top: 3%">
                  <v-col cols="12" md="12" style="
                    text-align: center;
                    font-size: 60px;
                    color: #344054;
                    font-weight: bold;
                  ">
                    {{ $t("message.Pleaseinsert") }}
                  </v-col>
                </v-row>
                   <v-row style="    display: flex;
    justify-content: flex-end;padding-right: 40px;padding-top: 10%">
                  <v-progress-circular color="#344054" indeterminate size="100 "></v-progress-circular>
                </v-row>
                <v-row style="margin-top: 5%">
                  <v-col cols="12" md="12" style="text-align: center">
                    <img @click="CapturePerson()" height="auto" width="400px" style="
                      padding-top: 0rem;
                      margin-left: auto;
                      margin-right: auto;
                      cursor: pointer;
                    " src="@/assets/id-card.png" />
                  </v-col>
                </v-row>
                <v-row style="margin-top: 25%">
                  <v-col cols="12" md="12" style="text-align: center">
                    <v-btn color="#344054" class="box white--text mt-2 text-capitalize" router width="500"
                      style="font-size: 45px; " height="100" @click="BackToIdentifySelection()">{{
                        $t("message.Back") }}</v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>

          </v-container>
        </v-sheet>
      </v-col>
    </v-row>
    <v-overlay v-model="LoadingDialog">
      <v-progress-circular indeterminate size="64">
        Loading...
      </v-progress-circular>
    </v-overlay>


  </div>
</template>
<script>
import axios from "axios";
import enurl from "@/api/environment";
// import ChangeLanguage from "@/components/ChangeLanguage";
export default {
  name: "NationalIDCard",
  components: {
    // ChangeLanguage,
  },
  data() {
    return {
      url: enurl.apiUrl,
      urlReader: enurl.apiReaderUrl,
      DefaultLogo: "@/assets/logo192.png",
      DefaultBG: "@/assets/1D2939.png",
      Datetime: "",
      LoadingDialog: false,
      PersonData: "",
      warningDialog: false,
      ResponsePassport: [],
      ResponseSmartCard: [],
      thaiPersonalInfo: [],
      englishPersonalInfo: [],
    };
  },

  mounted: function () {
    setInterval(() => {
      this.getCurrentDate();
    }, 1000);

    // let interval = setInterval(() => {
    //     this.getDataPersonWithThaiSmartCard();
    // }, 2000);

    // setTimeout(() => clearInterval(interval), 5000)
    // let a = true;
    // while(a){
    //   this.getDataPersonWithThaiSmartCard();
    //   if(this.PersonData != ""){
    //     break;
    //   }
    // }
  },

  methods: {
    getCurrentDate() {
      let self = this;
      let newDate = new Date();
      let date =
        newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
      let month = newDate.getMonth() + 1;
      let year =
        newDate.getFullYear() < 2500
          ? newDate.getFullYear() + 543
          : newDate.getFullYear();
      let hours =
        newDate.getHours() < 10 ? "0" + newDate.getHours() : newDate.getHours();
      let minutes =
        newDate.getMinutes() < 10
          ? "0" + newDate.getMinutes()
          : newDate.getMinutes();
      let seconds =
        newDate.getSeconds() < 10
          ? "0" + newDate.getSeconds()
          : newDate.getSeconds();
      self.Datetime = `${date}/${month < 10 ? `0${month}` : `${month}`
        }/${year}  ${hours}:${minutes}:${seconds}`;
    },

    getDataPersonWithThaiSmartCard() {
      let self = this;
      axios
        .get(`${self.urlReader}SmartCardReader/ThaiSmartCardReader`)
        .then(function (response) {
          if (response.data.status == 0) {
            // self.PersonData = response.data.data;
            self.ResponseSmartCard = response.data.data;
            self.englishPersonalInfo = response.data.data.englishPersonalInfo;
            self.thaiPersonalInfo = response.data.data.thaiPersonalInfo;
            self.addressInfo = response.data.data.addressInfo;
            self.LoadingDialog = false;
            // self.$router.push("/CapturePerson");
            // console.log(self.PersonData);

            let temp = {
              documentNumber: self.ResponseSmartCard.citizenID,
              prefixEN: self.englishPersonalInfo.prefix,
              firstnameEN: self.englishPersonalInfo.firstName,
              middlenameEN: self.englishPersonalInfo.middleName,
              lastnameEN: self.englishPersonalInfo.lastName,
              sexEN: self.ResponseSmartCard.sex,
              prefixTH: self.thaiPersonalInfo.prefix,
              firstnameTH: self.thaiPersonalInfo.firstName,
              middlenameTH: self.thaiPersonalInfo.middleName,
              lastnameTH: self.thaiPersonalInfo.lastName,
              sexTH: self.ResponseSmartCard.sex,
              type: "ID Card",
              image1: "",
              image2: "",
              tenantID: 0,
              towerID: 1,
              zoneID: 0,
              floorID: 0,
              locationID: 0,
            };

            self.$router.push({
              name: "CapturePerson",
              path: "/CapturePerson",
              params: {
                data: temp,
              },
            });

            // self.CapturePerson();
          }
        })
        .catch(function (error) {
          self.MessageAlert = error;
        });
    },

    BackToIdentifySelection() {
      let self = this;
      self.$router.push("/IdentifySelection");
    },

    BackToMain() {
      let self = this;
      self.$router.push("/MainMenu");
    },

    CapturePerson() {
      let self = this;
      self.getDataPersonWithThaiSmartCard();
      // self.$router.push("/CapturePerson");
    },

      skip() {
      let self = this;
      // self.getDataPersonWithThaiSmartCard();
      self.$router.push("/CapturePerson");
    },
  },
};
</script>
<style scoped>
@media all and (orientation: portrait) {
  .fullscreen {
    height: 1890px;
  }
}

@media all and (orientation: landscape) {
  .fullscreen {
    height: auto;
  }
}
</style>
